<template>
    <ManagementListPage title="Revisão de Crédito"
        subtitle="Solicitações de revisão de crédito submetidas pelos credores."
        :result-text="`${dataList.count} revisão${dataList.count === 1 ? '' : 'ões'} encontrada${dataList.count === 1 ? '' : 's'}`"
        :breadcrumbs="[{ text: 'Homepage', to: '/home', exact: true }, { text: 'Revisão de Crédito', disabled: true }]">
        <template v-slot:actions>

                        <v-menu offset-y transition="slide-y-reverse-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                    type="button" color="primary" elevation="0" v-bind="attrs" v-on="on">
                                    <v-icon left small>mdi-account-switch-outline</v-icon>Responsável<v-icon right small>mdi-chevron-down</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="modalRedirectMultiple = true" class="menu-item"
                                    title="Atribuir responsável em múltiplos pedidos">
                                    <v-list-item-icon>
                                        <v-icon>mdi-account-arrow-right-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Atribuir</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="modalAdminChange = true" class="menu-item"
                                    title="Substituir responsável em múltiplos pedidos">
                                    <v-list-item-icon>
                                        <v-icon>mdi-account-convert-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Substituir</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <!-- <v-btn v-if="$check(user, ['events.update.responsible.redirect'])" type="button" color="primary"
                            elevation="0" @click="modalRedirectMultiple = true">Atribuir<br />
                            Responsável
                        </v-btn> -->

                        <v-btn :disabled="!$check(user, ['objectionevents.update.contradictorydeadline'])" type="button"
                            outlined color="primary" elevation="0" @click="contraditoryModal = true">
                            <v-icon left small>mdi-calendar-clock-outline</v-icon>Prazo contraditório
                        </v-btn>
                        <!-- <v-btn class="text-center" type="button" color="primary" elevation="0"
                            to="/revisao-credito/novo">Adicionar<br />
                            Revisão de Crédito
                        </v-btn> -->
        </template>
        <!-- <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense id="id" label="Nº Pedido" v-model="dataList.filter.id"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="3">
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense id="registration" label="CPF/CNPJ"
                                        v-model="dataList.filter.registration" hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="3">
                                    <v-select dense :items="dataset.eventTypes" label="Tipo"
                                        v-model="dataList.filter.type" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete dense :items="dataset.clients" label="Caso"
                                        v-model="dataList.filter.client_id" item-value="id" item-text="name" outlined
                                        hide-details="auto" no-data-text="Nenhum caso encontrado">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="dataList.filter.creditor_type"
                                        :items="getFilterCreditorTypes()" item-text="name" item-value="id"
                                        label="Classe" outlined hide-details="auto"
                                        no-data-text="Nenhuma classe encontrada" dense></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select dense :items="dataset.hasContradictory" label="Contraditório"
                                        v-model="dataList.filter.has_contradictory" item-value="id" item-text="name"
                                        outlined hide-details="auto">
                                    </v-select>
                                </v-col>-->
        <!-- <v-col cols="12" sm="6">
                                    <v-select dense :items="dataset.eventStatus" label="Status"
                                        v-model="dataList.filter.status" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col> -->
        <!-- </v-row>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete :disabled="dataset.loading" dense
                                        :items="dataset.creditorOriginTypes" label="Origem do crédito"
                                        v-model="dataList.filter.origin" item-value="name" item-text="name" outlined
                                        hide-details="auto">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select dense :items="dataset.hasProcess" label="Processo"
                                        v-model="dataList.filter.has_process" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select dense :items="dataset.ufList" label="UF processo"
                                        v-model="dataList.filter.process_uf" item-value="name" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="process_number" label="Número processo"
                                        v-model="dataList.filter.process_number" hide-details outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-select dense :items="dataset.adminList" label="Responsável"
                                        v-model="dataList.filter.responsible" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>-->

        <!-- <template>
            <v-row>
                <v-col cols="12" sm="4">
                    <CardItemA icon="mdi-account-remove-outline" title="Divergências"
                        description="Total de hab/div divergências" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA icon="mdi-file-document-outline" title="Processos"
                        description="Total de hab/div com processos" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA icon="mdi-account-clock-outline" title="Pendentes"
                        description="Total de hab/div para análise" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA color="red" icon="mdi-account-question-outline" title="Contraditórios"
                        description="Total de hab/div verificados" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA color="green" icon="mdi-account-multiple-check-outline" title="Aprovados"
                        description="Total de hab/div aprovadas" value="N/A" />
                </v-col>
            </v-row>
        </template> -->

        <template v-slot:navigation>
                <v-tabs v-model="objectionVersionTab" class="management-list-tabs" @change="onObjectionVersionTabChange">
                    <v-tab>
                        <v-icon small left>mdi-calendar-check-outline</v-icon>
                        Tempestivas
                    </v-tab>
                    <v-tab>
                        <v-icon small left>mdi-clock-alert-outline</v-icon>
                        Intempestivas
                    </v-tab>
                </v-tabs>
        </template>
        <template v-slot:filters>
                    <v-form @submit.prevent="applyFilters">
                        <div class="op-filter-toolbar">
                            <v-text-field v-model="dataList.filter.content" dense outlined hide-details clearable
                                prepend-inner-icon="mdi-magnify" placeholder="Buscar por nome ou CPF/CNPJ"
                                @keyup.enter="applyFilters" />
                            <v-btn outlined color="primary" @click="showFilters = !showFilters">
                                <v-icon left small>mdi-tune-variant</v-icon>Filtros
                                <span v-if="activeFilterCount" class="op-filter-count">{{ activeFilterCount }}</span>
                                <v-icon right small>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                            <v-btn type="submit" color="primary" elevation="0">
                                <v-icon left small>mdi-magnify</v-icon>Buscar
                            </v-btn>
                        </div>
                        <v-expand-transition>
                        <div v-if="showFilters" class="op-filter-panel mt-3 pt-3">
                            <div class="op-filter-panel-head"><div><strong>Filtros avançados</strong><span>Refine as revisões exibidas na listagem.</span></div></div>
                            <div class="management-advanced-filters op-filter-grid">
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense id="id" label="Nº Pedido" v-model="dataList.filter.id"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="3">
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="auto" sm="3">
                                    <v-currency-field dense id="amount" type="number" label="Valor maior ou igual"
                                        v-model="dataList.filter.amount" outlined hide-details="auto"
                                        :allowNegative=false>
                                    </v-currency-field>
                                </v-col>

                                <v-col cols="12" sm="3">
                                    <v-text-field dense id="registration" label="CPF/CNPJ"
                                        v-model="dataList.filter.registration" hide-details outlined></v-text-field>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <v-select dense :items="dataset.eventTypes" label="Tipo"
                                        v-model="dataList.filter.type" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-autocomplete dense :items="dataset.clients" label="Caso"
                                        v-model="dataList.filter.client_id" item-value="id" item-text="name" outlined
                                        hide-details="auto" no-data-text="Nenhum caso encontrado">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-autocomplete v-model="dataList.filter.creditor_type"
                                        :items="getFilterCreditorTypes()" item-text="name" item-value="id"
                                        label="Classe" outlined hide-details="auto"
                                        no-data-text="Nenhuma classe encontrada" dense></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select dense :items="dataset.statusContradictory" label="Contraditório"
                                        v-model="dataList.filter.contradictory" item-value="id" item-text="name"
                                        outlined hide-details="auto">
                                    </v-select>
                                </v-col>
                                <!-- <v-col cols="12" sm="6">
                                    <v-select dense :items="dataset.eventStatus" label="Status"
                                        v-model="dataList.filter.status" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col> -->
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <v-autocomplete :disabled="dataset.loading" dense
                                        :items="dataset.creditorOriginTypes" label="Origem do crédito"
                                        v-model="dataList.filter.origin" item-value="name" item-text="name" outlined
                                        hide-details="auto">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select dense :items="dataset.hasProcess" label="Processo"
                                        v-model="dataList.filter.has_process" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select dense :items="dataset.ufList" label="UF processo"
                                        v-model="dataList.filter.process_uf" item-value="name" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select dense :items="dataset.hasInvalidDocId" label="Doc ID inválido"
                                        v-model="dataList.filter.has_invalid_doc_id" item-value="id" item-text="name"
                                        outlined hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete :disabled="dataset.loading" dense
                                        :items="dataset.objectionJustificationTypes" label="Justificativa"
                                        v-model="dataList.filter.justification_id" item-value="id" item-text="label"
                                        outlined hide-details="auto">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-select dense :items="dataset.hasFgtsAmount" label="Valor FGTS"
                                        v-model="dataList.filter.has_fgts_amount" item-value="id" item-text="name"
                                        outlined hide-details="auto">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense id="process_number" label="Número processo"
                                        v-model="dataList.filter.process_number" hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select dense :items="dataset.adminList" label="Responsável"
                                        v-model="dataList.filter.responsible" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            </div>
                        </div>
                        </v-expand-transition>

                        <div v-if="showFilters" class="op-filter-footer">
                            <span>{{ activeFilterCount ? `${activeFilterCount} filtro(s) ativo(s)` : 'Nenhum filtro adicional aplicado' }}</span>
                            <v-btn v-if="hasFilters()" text small color="primary" @click="clearFilters">Limpar filtros</v-btn>
                        </div>

                        <section class="op-quick-filters">
                            <div class="op-quick-filters-head">
                                <div><strong>Filtros rápidos</strong><span>Selecione uma categoria e uma situação.</span></div>
                                <span class="op-current-filter"><v-icon x-small>mdi-filter-check-outline</v-icon>{{ currentStatusLabel }}</span>
                            </div>
                            <div class="op-quick-filter-categories" role="tablist" aria-label="Categorias de filtros rápidos">
                                <button v-for="category in quickFilterCategories" :key="category.id" type="button"
                                    :class="{ active: normalizedCategoryTab === category.id }"
                                    @click="categoryTab = category.id">{{ category.label }}</button>
                            </div>
                            <div class="op-quick-filter-options">
                                <button v-for="tab in filteredTabs" :key="`${tab.category}-${tab.value}`" type="button"
                                    :class="{ active: isQuickChipSelected(tab) }" @click="onQuickChipClick(tab)">
                                    <v-icon x-small>{{ tab.icon }}</v-icon>{{ tab.label }}
                                </button>
                            </div>
                        </section>
                    </v-form>
        </template>
        <template v-slot:table>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma informação foi encontrada" loading-text="Carregando dados..."
                            class="management-list-table management-minimal-table app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.id`]="{ item }">
                                <div class="op-cell-id">
                                    <strong>{{ item.id }}</strong>
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="item.is_complex" v-on="on" color="warning" class="ml-1" small>
                                                mdi-alert-outline
                                            </v-icon>
                                        </template>
                                        <span>Item complexo</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="item.review_later" v-on="on" color="primary" class="ml-1"
                                                small>
                                                mdi-history
                                            </v-icon>
                                        </template>
                                        <span>Sinalizado para revisão posterior</span>
                                    </v-tooltip>

                                </div>
                           </template>

                            <template v-slot:header.created_at="{ header }">
                                <div class="d-flex align-center" style="cursor:pointer" @click="sortCreatedAt">
                                    <span class="font-weight-medium mr-1">
                                        {{ header.text }}
                                    </span>
                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" size="22"
                                                :color="sortDateDesc ? 'primary' : 'grey'">
                                                {{ sortDateDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                                            </v-icon>
                                        </template>
                                        <span>
                                            {{ sortDateDesc ? 'Ordenado do mais recente para o mais antigo' : 'Ordenado do mais antigo para o mais recente' }}
                                        </span>
                                    </v-tooltip>
                                </div>
                            </template>

                            <template v-slot:[`item.user.name`]="{ item }">
                                <span class="op-cell-primary text-capitalize">{{ item.user.name }}</span>
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <span class="op-table-badge" :class="`tone-${getRowStatusTone(item)}`">{{ getChipLabel(item) }}</span>
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                <span class="op-cell-secondary">{{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}</span>
                            </template>

                            <template v-slot:[`item.contradictory_deadline_at`]="{ item }">
                                <span
                                    v-if="item.contradictory_deadline_at && item.contradictory_deadline_at !== '0000-00-00 00:00:00'">
                                    {{ item.contradictory_deadline_at | defaultDate("DD/MM/YYYY") }}</span>
                                <span v-else class="op-cell-muted">—</span>
                            </template>

                            <!-- <template v-slot:[`item.type`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    :color="item.type == 2 ? '#00BCD4' : '#009688'" label text-color="white">
                                    {{ item.type == 2 ? 'Divergência' : 'Habilitação' }}
                                </v-chip>
                            </template> -->

                            <template v-slot:[`item.type`]="{ item }">
                                <span class="op-table-badge tone-neutral">{{ getTypeLabel(item.type) }}</span>
                            </template>

                            <template v-slot:[`item.admin`]="{ item }">
                                <span :class="{ 'op-cell-muted': !item.admin && item.analyzed_at === '0000-00-00 00:00:00' }">{{
                                    item.admin && item.admin.name
                                        ? item.admin.name
                                        : item.analyzed_at !== "0000-00-00 00:00:00" && !item.admin
                                            ? "Sistema"
                                            : "—"
                                }}</span>
                            </template>

                            <!-- <template v-slot:[`item.admin`]="{ item }">
                                {{ item.admin && item.admin.name ? item.admin.name : 'N/A' }}
                            </template> -->

                            <template v-slot:[`item.responsible_admin_id`]="{ item }">
                                <span :class="{ 'op-cell-muted': !item.responsible_admin_id }">{{ item.responsible_admin_id ? getAdminName(item.responsible_admin_id) : '—' }}</span>
                            </template>

                            <template v-slot:[`item.analyzed_at`]="{ item }">
                                <span v-if="item.analyzed_at && item.analyzed_at !== '0000-00-00 00:00:00'"> {{
                                    item.analyzed_at |
                                    defaultDate("DD/MM/YYYY HH:mm:ss") }}</span>
                                <span v-else class="op-cell-muted">—</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <div class="op-row-actions">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" icon x-small :disabled="!$check(user, ['objectionevents.find'])"
                                                @click="viewItem(item)"><v-icon small>mdi-eye-outline</v-icon></v-btn>
                                        </template>
                                        <span>Visualizar informações</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" icon x-small :disabled="!$check(user, ['objectionevents.update'])"
                                                @click="viewItem(item)"><v-icon small>mdi-pencil-outline</v-icon></v-btn>
                                        </template>
                                        <span>Editar informações</span>
                                    </v-tooltip>

                                    <v-tooltip v-if="item.responsible_admin_id === null" bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" icon x-small
                                                :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                                @click="redirectItem(item)"><v-icon small>mdi-share-outline</v-icon></v-btn>
                                        </template>
                                        <span>Direcionar para outro responsável</span>
                                    </v-tooltip>

                                    <v-tooltip v-else bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" icon x-small color="error"
                                                :disabled="!$check(user, ['objectionevents.update.responsible.remove'])"
                                                @click="removeResponsible(item)"><v-icon small>mdi-refresh</v-icon></v-btn>
                                        </template>
                                        <span>Remover Responsável</span>
                                    </v-tooltip>

                                </div>
                            </template>

                            <template v-slot:footer.prepend>
                                <v-spacer></v-spacer>
                                <v-text-field v-model.number="targetPage" type="number" min="1" :max="maxPage"
                                    label="Página" hide-details dense outlined class="mx-2"
                                    style="max-width: 80px;"></v-text-field>
                                <v-btn icon @click="goToPage">
                                    <v-icon>mdi-check</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
        </template>

        <!-- Modal Redirect Admin Responsible-->
        <v-dialog v-model="modalAdminRedirect" max-width="600px">
            <v-card>
                <v-card-title class="text-center text--darken-2"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Atribuir Revisão de Crédito
                </v-card-title>
                <br>
                <v-card-text>
                    <p>
                        Selecione o responsável para o qual deseja atribuir esta Revisão de Crédito.
                    </p>

                    <p>Revisão de Crédito número: <strong>{{ redirectAdminId }}</strong></p>
                    <br>
                    <v-form ref="contraditoryForm" @submit.prevent="saveResponsibleAdmin">
                        <v-row>
                            <v-col cols="12" sm="12">

                                <v-autocomplete v-model="dataset.redirect.responsible_admin_id" :items="dataset.admins"
                                    item-text="name" item-value="id" label="Selecionar responsável" outlined
                                    hide-details="auto" no-data-text="Nenhum responsável encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row v-if="!$check(user, ['objectionevents.update.complexity'])">
                            <v-col cols="12" sm="12">
                                <v-checkbox v-model="dataset.redirect.is_complex" label="Marcar item como complexo"
                                    dense></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn text color="grey" @click="closeModalAdminRedirect()">Cancelar</v-btn>
                            <v-btn :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                color="primary" type="submit" :loading="loadingAdminRedirect">Salvar</v-btn>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal -->
        <v-dialog v-model="contraditoryModal" max-width="600px">
            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    PRAZO CONTRADITÓRIO
                </v-card-title>
                <br>
                <v-card-text>
                    <p>
                        Entre com o número da Revisão de Crédito Inicial, Final e a Data do prazo contraditório.
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-icon small color="primary" class="ml-2" v-bind="attrs"
                                    v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <span>Ex.: Inicial: 100 - Final: 500 - Prazo: 01/01/2025. <br>Todas as Revisões de Crédito
                                entre 100
                                a
                                500, serão marcadas com prazo contraditório de 01/101/2025</span>
                        </v-tooltip>
                    </p>
                    <br>
                    <v-form ref="contraditoryForm" @submit.prevent="saveContraditory">
                        <v-row class="mb-n5">
                            <v-col cols="12" sm="6">
                                <v-text-field dense id="star_value" type="number" label="Inicial"
                                    v-model="contraditory.start_value"
                                    :rules="[value => /^\d+$/.test(value) || 'Somente números positivos são permitidos']"
                                    outlined>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field dense id="end_value" type="number" label="Final"
                                    v-model="contraditory.end_value"
                                    :rules="[value => /^\d+$/.test(value) || 'Somente números positivos são permitidos']"
                                    outlined>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="290px">
                                    <template #activator="{ on, attrs }">
                                        <v-text-field v-model="formattedContaditoryDate" label="Data contraditório"
                                            prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" @blur="updateStartDate"
                                            outlined dense></v-text-field>
                                    </template>
                                    <v-date-picker v-model="contraditory.deadline_date" locale="pt-BR" scrollable
                                        @input="formatStartDate" @change="menuStart = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn text color="grey" @click="closeContraditoryModal">Cancelar</v-btn>
                            <v-btn :disabled="!$check(user, ['objectionevents.update.contradictorydeadline'])"
                                color="primary" type="submit" :loading="loadingContraditory">Salvar</v-btn>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal substituir de um responsavel para outro em multiplas hab-div-->
        <v-dialog v-model="modalAdminChange" max-width="600px">

            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Substituir Responsável
                </v-card-title>
                <br>
                <v-card-text>
                    <p class="mb-2">
                        Preencha os dados abaixo para transferir os pedidos de um responsável para outro.
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-icon small color="primary" class="ml-2" v-bind="attrs"
                                    v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <span>Caso o campo "Quantidade" não for preenchido, todos os registros encontrados <br>
                                com base nas regras selecionadas, serão transferidos para o responsável de destino.
                            </span>
                        </v-tooltip>
                    </p>
                    <br>
                    <v-form ref="changeResponsibleForm" @submit.prevent="saveAdminChange">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field dense id="quantity" type="number" label="Quantidade"
                                    v-model="dataset.changeResponsible.rec_quantity" outlined hide-details="auto"
                                    :rules="[value => value === '' || value === null || /^\d+$/.test(value) || 'Somente números positivos são permitidos']"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.changeResponsible.has_process"
                                    :items="dataset.hasProcess" item-text="name" item-value="id" label="Processo"
                                    outlined hide-details="auto" no-data-text="Nenhum valor encontrado"
                                    dense></v-autocomplete>
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="dataset.changeResponsible.status" :items="dataset.eventStatus"
                                    item-text="name" item-value="id" label="Status" outlined hide-details="auto"
                                    no-data-text="Nenhum status encontrado" dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="dataset.changeResponsible.from_responsible_id"
                                    :items="dataset.admins" item-text="name" item-value="id"
                                    label="Responsável de origem" outlined hide-details="auto" required
                                    :rules="[$rules.required]" no-data-text="Nenhum responsável encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="dataset.changeResponsible.to_responsible_id"
                                    :items="dataset.admins" item-text="name" item-value="id"
                                    label="Responsável de destino" outlined hide-details="auto" required
                                    :rules="[$rules.required]" no-data-text="Nenhum responsável encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <br>
                        <v-row justify="end">
                            <v-col cols="auto">
                                <v-btn text color="grey" @click="closeModalChangeResponsible">Cancelar</v-btn>
                                <v-btn color="primary" type="submit"
                                    :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                    :loading="loadingAdminChange">Salvar</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal atribuir multiplos pedidos de revisão para um responsavel-->
        <v-dialog v-model="modalRedirectMultiple" max-width="600px">

            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Atribuir Responsável
                </v-card-title>
                <br>
                <v-card-text>

                    <p class="mb-2">
                        Preencha os dados abaixo para atribuir pedidos para um responsável.
                    </p>
                    <br>
                    <v-form ref="redirectMultipleForm" @submit.prevent="saveRedirectMultiple">
                        <v-row class="mb-n5">
                            <v-col cols="12" sm="6">
                                <v-text-field dense id="qtRequest" type="number" label="Total pedidos"
                                    v-model="dataset.redirectMultiple.req_quantity" outlined hide-details="auto"
                                    :rules="[value => /^\d+$/.test(value) || 'Somente números positivos são permitidos']"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.redirectMultiple.creditor_type"
                                    :items="dataset.creditorTypes" item-text="name" item-value="id" label="Classe"
                                    outlined hide-details="auto" no-data-text="Nenhuma classe encontrada"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="mb-n5">
                            <v-col cols="12" sm="6">
                                <v-currency-field dense id="qtAmountPlus" type="number" label="Valor igual ou maior"
                                    v-model="dataset.redirectMultiple.amount_plus" outlined hide-details="auto"
                                    :allowNegative=false>
                                </v-currency-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-currency-field dense id="qtAmountMinus" type="number" label="Valor igual ou menor"
                                    v-model="dataset.redirectMultiple.amount_minus" outlined hide-details="auto"
                                    :allowNegative=false>
                                </v-currency-field>
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.redirectMultiple.fgts_amount"
                                    :items="dataset.hasFgtsAmount" item-text="name" item-value="id" label="Valor FGTS"
                                    outlined hide-details="auto" no-data-text="Nenhum valor fgts encontrado"
                                    dense></v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.redirectMultiple.has_contradictory"
                                    :items="dataset.hasContradictory" item-text="name" item-value="id"
                                    label="Contraditório" outlined hide-details="auto"
                                    no-data-text="Nenhum contraditório encontrado" dense></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.redirectMultiple.has_process"
                                    :items="dataset.hasProcess" item-text="name" item-value="id" label="Processo"
                                    outlined hide-details="auto" no-data-text="Nenhum valor encontrado"
                                    dense></v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.redirectMultiple.process_court_uf"
                                    :items="dataset.courtProcessUf" item-text="name" item-value="name"
                                    label="Tribunal UF"
                                    :disabled="dataset.redirectMultiple.has_process !== 'sim' && dataset.redirectMultiple.has_process !== 1"
                                    outlined hide-details="auto" no-data-text="Nenhum tribunal encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="dataset.redirectMultiple.creditor_origin"
                                    :items="dataset.creditorOrigin" item-text="name" item-value="name"
                                    label="Origem do negócio" outlined hide-details="auto"
                                    no-data-text="Nenhum negócio encontrado" dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>

                            <v-col cols="12" sm="12">
                                <v-autocomplete :disabled="dataset.loading" dense
                                    :items="dataset.objectionJustificationTypes" label="Justificativa"
                                    v-model="dataset.redirectMultiple.justification_id" item-value="id"
                                    item-text="label" outlined hide-details="auto"
                                    no-data-text="Nenhuma justificativa encontrada">
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="dataset.redirectMultiple.responsible_id"
                                    :items="dataset.admins" item-text="name" item-value="id"
                                    label="Selecionar responsável" outlined hide-details="auto" required
                                    :rules="[$rules.required]" no-data-text="Nenhum responsável encontrado" dense>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-checkbox v-model="dataset.redirectMultiple.without_responsible" dense>
                                    <template #label>
                                        <span class="d-inline-flex align-center">
                                            Somente sem responsável
                                            <v-tooltip bottom>
                                                <template #activator="{ on, attrs }">
                                                    <v-icon small color="primary" class="ml-2" v-bind="attrs" v-on="on">
                                                        mdi-help-circle
                                                    </v-icon>
                                                </template>
                                                <span>
                                                    Ao marcar esta opção, o responsável selecionado será atribuído à
                                                    Revisão de Crédito
                                                    <br />
                                                    que se enquadre nas regras selecionadas e que ainda não possua um
                                                    responsável designado.
                                                </span>
                                            </v-tooltip>
                                        </span>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>

                        <br>
                        <v-row justify="end">
                            <v-col cols="auto">
                                <v-btn text color="grey" @click="closeModalRedirectMultiple">Cancelar</v-btn>
                                <v-btn color="primary" type="submit"
                                    :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                    :loading="loadingResponsibleRedirect">Salvar</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </ManagementListPage>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import eventStatus from "@/common/data/event-status.data";
import statusContradictory from "@/common/data/contradictory-status.data";
import ufList from "@/common/data/uf-list.data";
import creditorTypes from "@/common/data/creditor-types.data";
import creditorOriginTypes from "@/common/data/creditor-origin-types.data";
import creditorOrigin from "@/common/data/creditor-origin-types.data";
import courtProcessUf from "@/common/data/states-list.data";
import objectionEventTypes from "@/common/data/objection-event-types.data";
import objectionJustificationTypes from "@/common/data/objection-justification-types.data";
import reasonEventList from "@/common/data/reason-event-list.data";

// import CardItemA from "@/layouts/components/CardItemA";

const STORAGE_KEY = 'creditor_revision_filters'

Vue.use(VueLodash)

export default {
    name: "UserList",

    // components: {
    //     CardItemA,
    // },

    data: () => ({
        user: null,
        targetPage: 1,
        showFilters: false,
        objectionVersionTab: 0,
        currentStatusLabel: 'Todos',
        categoryTab: 'status',
        selectedStatus: '',
        selectedQuickChipKey: 'status-',
        selectedQuickFilter: { category: 'status', value: '' },
        flashChipValue: null,
        sortDateDesc: true,
        tabs: [
            // STATUS
            { category: 'status', value: '', label: 'Todos', icon: 'mdi-format-list-bulleted', color: 'grey' },
            { category: 'status', value: 0, label: 'Pendente', icon: 'mdi-timer-sand', color: 'warning' },
            { category: 'status', value: 1, label: 'Aprovado', icon: 'mdi-check-circle-outline', color: 'green' },
            { category: 'status', value: 2, label: 'Rejeitado', icon: 'mdi-close-circle-outline', color: 'error' },
            { category: 'status', value: 3, label: 'Aprovado Parcial', icon: 'mdi-check-decagram-outline', color: 'indigo' },
            { category: 'status', value: 6, label: 'Em Revisão', icon: 'mdi-eye-outline', color: 'blue' },

            //CONTRAPROPOSTA DEVEDORA
            { category: 'proposal-1', value: 8, label: 'Enviada', icon: 'mdi-send-outline', color: '#9E9D24' },
            { category: 'proposal-1', value: 9, label: 'Rejeitada', icon: 'mdi-cancel', color: '#BF360C' },
            { category: 'proposal-1', value: 10, label: 'Aceita', icon: 'mdi-check-bold', color: '#00695C' },
            { category: 'proposal-1', value: 7, label: 'Sem retorno', icon: 'mdi-help-circle-outline', color: '#00695C' },

            //CONTRAPROPOSTA QGC
            { category: 'proposal-2', value: 11, label: 'Todos', icon: 'mdi-format-list-bulleted', color: '#00695C' },
            { category: 'proposal-2', value: 16, label: 'Enviada', icon: 'mdi-send-outline', color: 'blue' },
            { category: 'proposal-2', value: 17, label: 'Rejeitada', icon: 'mdi-cancel', color: '#BF360C' },
            { category: 'proposal-2', value: 18, label: 'Aceita', icon: 'mdi-check-bold', color: '#00695C' },

            //CONTRAPROPOSTA CONTRADITÓRIO
            { category: 'proposal-3', value: 12, label: 'Enviada', icon: 'mdi-send-outline', color: 'deep-purple' },
            { category: 'proposal-3', value: 13, label: 'Rejeitada', icon: 'mdi-cancel', color: '#BF360C' },
            { category: 'proposal-3', value: 14, label: 'Aceita', icon: 'mdi-check-bold', color: '#00695C' },
            
            //OUTROS FILTROS
            { category: 'others', value: 15, label: 'Credor', icon: 'mdi-account', color: '#009688' },
            { category: 'others', value: 4, label: 'Docs Solicitados', icon: 'mdi-file-alert-outline', color: '#00695C' },
            { category: 'others', value: 5, label: 'Docs Atualizados', icon: 'mdi-file-refresh-outline', color: '#29B6F6' },
            { category: 'others', value: 19, label: 'Intempestivo', icon: 'mdi-clock-alert-outline', color: '#FB8C00' },
        ],
        quickFilterCategories: [
            { id: 'status', label: 'Status' },
            { id: 'proposal-1', label: 'Contrap. devedora' },
            { id: 'proposal-2', label: 'Contrap. QGC' },
            { id: 'proposal-3', label: 'Contrap. contraditório' },
            { id: 'others', label: 'Outros' },
        ],
 
        dataset: {
            eventStatus: [{ id: "", name: "Todos", }, { id: 7, name: "Sem retorno" }, ...eventStatus],
            statusContradictory: [{ id: "", name: "Todos" }, ...statusContradictory],
            eventTypes: [{ id: "", name: "Todos" }, { id: 1, name: "Habilitação" }, { id: 2, name: "Divergência" }],
            hasProcess: [{ id: "", name: "Todos" }, { id: 1, name: "SIM" }, { id: 2, name: "NÃO" }],
            hasInvalidDocId: [{ id: "", name: "Todos" }, { id: 1, name: "SIM" }, { id: 2, name: "NÃO" }],
            hasContradictory: [{ id: "", name: "Todos" }, { id: 1, name: "SIM" }, { id: 2, name: "NÃO" }],
            ufList: [{ id: "", name: "Todos" }, ...ufList],
            creditorTypes: creditorTypes,
            creditorOriginTypes: [{ name: "Todos" }, ...creditorOriginTypes,],
            creditorOrigin: creditorOrigin,
            courtProcessUf: courtProcessUf,
            objectionEventTypes: objectionEventTypes,
            objectionJustificationTypes: [{ id: "", label: "Todos" }, ...objectionJustificationTypes],
            reasonEventList: [{ id: "", name: "Todas" }, ...reasonEventList],
            hasFgtsAmount: [{ id: "", name: "Todos" }, { id: 1, name: "SIM" }, { id: 2, name: "NÃO" }],
            data: {},
            clients: [],
            admins: [],
            adminList: [],
            companyNameMap: {
                1: "123 VIAGENS E TURISMOS LTDA",
                2: "MM TURISMO & VIAGENS S.A",
                3: "NOVUM INVESTIMENTOS PARTICIPAÇÕES S/A",
                4: "ART VIAGENS E TURISMO LTDA",
                5: "LH - LANCE HOTÉIS LTDA",
            },
            isAdmin: false,
            redirect: {
                responsible_admin_id: null,
                is_complex: null
            },
            changeResponsible: {
                status: "",
                from_responsible_id: null,
                to_responsible_id: null,
                rec_quantity: null,
                has_process: ""
            },
            redirectMultiple: {
                responsible_id: null,
                req_quantity: null,
                amount_plus: null,
                amount_minus: null,
                fgts_amount: null,
                without_responsible: false,
                creditor_type: null,
                creditor_origin: null,
                process_court_uf: null,
                has_contradictory: null,
                justification_id: null,
            },
        },
        modalAdminRedirect: false,
        modalAdminChange: false,
        modalRedirectMultiple: false,
        loadingAdminRedirect: false,
        redirectAdminId: null,
        loadingContraditory: false,
        loadingResponsibleRedirect: false,
        loadingAdminChange: false,
        contraditoryModal: false,
        menuStart: false,
        menuEnd: false,
        formattedContaditoryDate: "",
        formattedEndDate: "",
        contraditory: {
            deadline_date: null,
            start_value: null,
            end_value: null,
        },
        dataList: {
            filter: {
                content: "",
                name: "",
                status: "",
                type: "",
                client_id: "",
                has_process: "",
                process_uf: "",
                process_number: "",
                responsible: "",
                creditor_type: "",
                origin: "",
                has_invalid_doc_id: "",
                justification_id: "",
                has_fgts_amount: "",
                id: "",
                amount: "",
                registration: "",
                contradictory: "",
                company_name: "",
            },
            headers: [
                { text: "Nº Pedido", value: "id", sortable: false },
                { text: "Credor", value: "user.name", sortable: false },
                { text: "Tipo", value: "type", sortable: false },
                { text: "Solicitado em", value: "created_at", sortable: false },
                { text: "Analisado por", value: "admin", sortable: false },
                { text: "Analisado em", value: "analyzed_at", sortable: false },
                { text: "Responsável", value: "responsible_admin_id", sortable: false },
                { text: "Contraditório", value: "contradictory_deadline_at", sortable: false },
                { text: "Status", value: "status", sortable: false },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                //  targetPage: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
            }
        },
    }),

    created() {
        this.loadFiltersFromStorage();
        this.loadUserData();
        this.loadClients();
        this.loadAdmins();
        this.load();
        
        this.$watch('dataset.admins', (newAdmins) => {
            this.dataset.adminList = [{ id: "", name: "Todos" }, { id: -1, name: "Sem responsável" }, ...newAdmins];
        }, { immediate: true });
    },

    computed: {
        activeFilterCount() {
            return Object.entries(this.dataList.filter)
                .filter(([key, value]) => key !== 'content' && key !== 'status' && value !== '' && value !== null).length;
        },

        maxPage() {
            return Math.ceil(this.dataList.count / this.dataList.options.itemsPerPage);
        },

        normalizedCategoryTab() {
            if (typeof this.categoryTab === 'string') return this.categoryTab.replace('#', '');
            const order = ['status', 'proposal-1', 'proposal-2', 'proposal-3', 'others'];
            return order[this.categoryTab] || 'status';
        },

        filteredTabs() {
            return this.tabs.filter(t => t.category === this.normalizedCategoryTab);
        },

        currentStatusLabelParts() {
            if (!this.currentStatusLabel || !this.currentStatusLabel.includes(' - ')) {
                return { prefix: this.currentStatusLabel, suffix: null };
            }
            const parts = this.currentStatusLabel.split(' - ');
            return {
                prefix: parts[0],
                suffix: parts.slice(1).join(' - ')
            };
        },

        currentSelectedChipKey() {
            const category =
            (this.selectedQuickFilter && this.selectedQuickFilter.category)
                ? String(this.selectedQuickFilter.category).replace('#', '')
                : this.normalizedCategoryTab;

            const value = this.normalizeStatusValue(
            this.selectedQuickFilter && this.selectedQuickFilter.value !== undefined
                ? this.selectedQuickFilter.value
                : this.dataList.filter.status
            );

            return `${category}-${String(value)}`;
        },
    },

    watch: {
        "dataset.redirectMultiple.has_process"(newValue) {

            if (newValue !== "sim" && newValue !== 1) {
                this.dataset.redirectMultiple.process_court_uf = null;
            }
        },
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load(false);
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(false);
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.selectedStatus = '';
            this.currentStatusLabel = 'Todos';
            this.categoryTab = 'status';
            this.selectedQuickFilter = { category: 'status', value: '' };
            this.syncQuickTabIndexByStatus('');
            this.saveFiltersToStorage();
            this.applyFilters();
        },

        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        clearNameSearch() {
            this.dataList.filter.content = "";
            this.load();
        },

        goToPage() {
            //const maxPage = Math.ceil(this.dataList.count / this.dataList.options.itemsPerPage);
            this.targetPage = Math.min(Math.max(this.targetPage, 1), maxPage);
            this.pageChanged(this.targetPage);
        },

        isQuickChipSelected(tab) {
            const key = this.chipKey(tab);
           const match = this.selectedQuickChipKey === key;
          return match;
        },

        setFilterStatus(status) {
            const normalized = this.normalizeStatusValue(status);
            this.quickStatus = normalized;
            this.selectedStatus = normalized;
            this.dataList.filter.status = normalized;
            this.currentStatusLabel = this.getStatusLabel(normalized);
            this.saveFiltersToStorage();
            this.load();
        },

        onQuickChipClick(tab) {
            const normalized = this.normalizeStatusValue(tab.value);

            this.categoryTab = String(tab.category).replace('#', '');
            this.selectedStatus = normalized;
            this.dataList.filter.status = normalized;
            this.selectedQuickFilter = { category: this.categoryTab, value: normalized };
            this.selectedQuickChipKey = this.chipKey(tab);

            this.currentStatusLabel = this.getStatusLabel(normalized);

            this.flashChipValue = this.chipKey(tab);
            if (this.flashChipTimeout) clearTimeout(this.flashChipTimeout);
            this.flashChipTimeout = setTimeout(() => {
                this.flashChipValue = null;
            }, 150);

            this.saveFiltersToStorage();
            this.load();
        },

        normalizeCategoryTabValue(value) {
            if (typeof value === 'string') return value.replace('#', '');

            const order = ['status', 'proposal-1', 'proposal-2', 'proposal-3', 'others'];
            return order[value] || 'status';
        },

        getStatusLabel(status) {
            const labels = {
                '': 'STATUS - Todos',
                0: 'STATUS - Pendente',
                1: 'STATUS - Aprovado',
                2: 'STATUS - Rejeitado',
                3: 'STATUS - Aprovado Parcial',
                4: 'OUTROS - Documentos Solicitados',
                5: 'OUTROS - Documentos Atualizados',
                6: 'STATUS - Em Revisão',
                7: 'CONTRAPROPOSTA DEVEDORA - Sem retorno',
                8: 'CONTRAPROPOSTA DEVEDORA - Enviada',
                9: 'CONTRAPROPOSTA DEVEDORA - Rejeitada',
                10: 'CONTRAPROPOSTA DEVEDORA - Aceita',
                11: 'CONTRAPROPOSTA QGC - Devedora',
                12: 'CONTRAPROPOSTA CONTRADITÓRIO - Enviada',
                13: 'CONTRAPROPOSTA CONTRADITÓRIO - Rejeitada',
                14: 'CONTRAPROPOSTA CONTRADITÓRIO - Aceita',
                15: 'OUTROS - Credor',
                16: 'CONTRAPROPOSTA QGC - Enviada',
                17: 'CONTRAPROPOSTA QGC - Rejeitada',
                18: 'CONTRAPROPOSTA QGC - Aceita',
                19: 'OUTROS - Intempestivo',
            };
          
            return labels[status] || 'Todos';
        },

        normalizeStatusValue(value) {
            if (value === '' || value === null || value === undefined) return '';
            const n = Number(value);
            return Number.isNaN(n) ? '' : n;
        },

        chipKey(tab) {
            const cat = String(tab.category).replace('#', '');
         const val = String(this.normalizeStatusValue(tab.value));
           return `${cat}-${val}`;
        },

        syncQuickTabIndexByStatus(status) {
            const tabOrder = ['', 0, 1, 3, 2, 6, 4, 5, 12, 14, 13, 8, 9, 10, 7, 11, 15];
            const normalized = this.normalizeStatusValue(status);
            const idx = tabOrder.findIndex(v => v === normalized);
            this.quickTabIndex = idx >= 0 ? idx : 0;
       },

        async removeResponsible(item) {
            try {
                const confirmAction = await this.$dialog.confirm({
                    text: "Tem certeza de que deseja remover o responsável?",
                    title: "Confirmar remoção",
                    actions: {
                        false: "Cancelar",
                        true: "Confirmar",
                    },
                });

                if (!confirmAction) {
                    return;
                }

                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-objection-events/remove-responsible/${item.id}`);

                this.$set(item, 'responsible_admin_id', null);

                this.$dialog.notify.info("Responsável removido com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { //"Erro ao remover o responsável. Tente novamente.", {
                    position: "top-right",
                    timeout: 3000,
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning';
                case 1:
                    return 'accent';
                case 2:
                    return 'error';
                case 3:
                    return 'indigo darken-1';
                default:
                    return 'grey';
            }
        },

        getChipColor(item) {
            if (item.currentReview && item.currentReview.status == 0) {
                return "#9FA8DA";
            }

            if (item.status == 4) {
                return "#7E55AB";
            }

            if (item.status == 5) {
                return "#29B6F6";
            }

            if (item.status == 6) {
                return "#9E9D24";
            }

            if (item.status == 7) {
                if (item.proposal_status === 1) {
                    return "#00695C";
                }
                if (item.proposal_status === 2) {
                    return "#BF360C";
                }
                return "#FFC107";
            }

            return this.getColorByStatus(item.status);
        },

        getChipLabel(item) {
            if (item.currentReview && item.currentReview.status == 0) {
                return "Em análise";
            }

            if (item.status === 7) {
                if (item.proposal_status === 1) {
                    return "Contraproposta Aceita";
                }
                if (item.proposal_status === 2) {
                    return "Contraproposta Rejeitada";
                }
            }

            return this.enum(item.status, this.dataset.eventStatus, "id", "name");
        },

        getRowStatusTone(item) {
            if (item.currentReview && item.currentReview.status == 0) return 'purple';
            if (item.status === 1) return 'success';
            if (item.status === 2) return 'danger';
            if ([0, 4, 6].includes(item.status)) return 'warning';
            if (item.status === 7 && item.proposal_status === 1) return 'success';
            if (item.status === 7 && item.proposal_status === 2) return 'danger';
            return 'neutral';
        },

        enum(status, eventStatus, idKey, nameKey) {
            const matchedStatus = eventStatus.find((e) => e[idKey] === status);
            return matchedStatus ? matchedStatus[nameKey] : 'Desconhecido';
        },

        getTypeColor(type) {
            switch (type) {
                case 1:
                    return '#009688';
                case 2:
                    return '#00BCD4';
                case 3:
                    return '#5C6BC0';
                case 4:
                    return '#00BCD4';
                default:
                    return 'grey';
            }
        },

        getTypeLabel(type) {
            return (this.dataset.objectionEventTypes.find(x => x.id === type) || {}).name || 'N/A';
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },
        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },

        closeModalAdminRedirect() {
            this.dataset.redirect.responsible_admin_id = null;
            this.dataset.redirect.is_complex = null;
            this.modalAdminRedirect = false;
        },

        closeModalRedirectMultiple() {
            this.dataset.redirectMultiple.req_quantity = null;
            this.dataset.redirectMultiple.creditor_type = null;
            this.dataset.redirectMultiple.creditor_origin = null;
            this.dataset.redirectMultiple.amount_minus = null;
            this.dataset.redirectMultiple.fgts_amount = null;
            this.dataset.redirectMultiple.justification_id = null;
            this.dataset.redirectMultiple.amount_plus = null;
            this.dataset.redirectMultiple.has_process = null;
            this.dataset.redirectMultiple.process_court_uf = null;
            this.dataset.redirectMultiple.responsible_id = null;
            this.dataset.redirectMultiple.has_contradictory = null;
            this.dataset.redirectMultiple.without_responsible = false;

            this.modalRedirectMultiple = false;
        },

        closeModalChangeResponsible() {
            this.dataset.changeResponsible.status = "";
            this.dataset.changeResponsible.from_responsible_id = null;
            this.dataset.changeResponsible.to_responsible_id = null;
            this.dataset.changeResponsible.rec_quantity = null;
            this.dataset.changeResponsible.has_process = "";
            this.modalAdminChange = false;
        },

        closeContraditoryModal() {
            this.contraditory.start_value = 0;
            this.contraditory.end_value = 0;
            this.contraditory.deadline_date = null;
            this.formattedContaditoryDate = null;
            this.contraditoryModal = false;
        },

        getAdminName(responsibleAdminId) {
            if (!responsibleAdminId) {
                return "N/A";
            }
            const admin = this.dataset.admins.find(admin => admin.id === responsibleAdminId);
            return admin ? admin.name : "N/A";
        },

        getFilterCreditorTypes() {
            return [{ "id": "", "name": "Todos" }, ...this.dataset.creditorTypes]
        },

        redirectItem(item) {
            this.redirectAdminId = item.id
            this.modalAdminRedirect = true;;
        },

        async loadUserData() {

            this.isAdmin = false;

            try {

                const userData = localStorage.getItem('user');

                if (userData) {
                    const user = JSON.parse(userData);

                    if (user.data.profile === 1) {
                        this.isAdmin = true;
                    }
                }
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 3000 });
            }
        },
        parseDate(date) {
            if (!date) return null;
            const [day, month, year] = date.split("/");
            return `${year}-${month}-${day}`;
        },

        formatStartDate(date) {
            this.formattedContaditoryDate = this.formatDate(date);
        },

        updateStartDate() {
            this.contraditory.deadline_date = this.parseDate(this.formattedContaditoryDate);
        },

        async load(saveFilters = true) {
            this.user = this.$root.user.data || this.$root.user;

            if (this.dataList.filter.process_uf === "Todos") {
                this.dataList.filter.process_uf = null;
            }

            if (saveFilters) {
                this.saveFiltersToStorage();
            }

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v));

            search = !object.isEmpty(search) ? search : {};

            if (search.origin) {
                search.origin = search.origin == "Todos" ? "" : search.origin
            }

            //conversão do `client_id` para `company_name`
            if (search.client_id) {
                search.company_name = this.dataset.companyNameMap[search.client_id];
                delete search.client_id;
            }

            if (this.dataList.filter.status === 0) search.status = 0;

            // Envia version conforme a aba selecionada
            search.version = this.objectionVersionTab === 0 ? 1 : 2;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;

            try {
                const result = await axios.get('/api/admin/user-objection-events/list', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.dataList.loading = false;
            }
        },

        async loadClients() {
            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data;

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataset.clients = [{ id: "", name: "Todos" }, ...data];
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadAdmins() {
            try {
                const result = await axios.get(`/api/admin/list`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data;

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataset.admins = data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async saveResponsibleAdmin() {

            if (!this.dataset.redirect.responsible_admin_id && !this.dataset.redirect.is_complex) {
                this.$dialog.notify.error(
                    "Por favor selecione um responsável ou marque o item como complexo!",
                    { position: 'top-right', timeout: 5000 }
                );

                return;
            }

            const payload = {
                responsible_admin_id: this.dataset.redirect.responsible_admin_id,
                is_complex: this.dataset.redirect.is_complex
            };

            this.loadingAdminRedirect = true;

            try {
                const response = await axios.patch(`/api/admin/user-objection-events/responsible-event-redirect/${this.redirectAdminId}`, payload);

                this.$dialog.notify.info("Alteração efetuada com sucesso!", { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {

                this.loadingAdminRedirect = false;
                this.modalAdminRedirect = false;
                this.redirectAdminId = null;
                this.dataset.redirect.responsible_admin_id = null;
                this.dataset.redirect.is_complex = null;
                this.load();
            }
        },

        async saveContraditory() {

            if (!this.formattedContaditoryDate || !this.contraditory.start_value || !this.contraditory.end_value) {
                this.$dialog.notify.error(
                    "Por favor entre com os valores Inicial, Final e Data do contraditório",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            }

            if (Number(this.contraditory.end_value) <= Number(this.contraditory.start_value)) {
                this.$dialog.notify.error(
                    "O valor final deve ser maior do que o valor inicial.",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Confirme a alteração dos dados:<br>
                - Habilitação/Divergência Inicial: <strong>${this.contraditory.start_value}</strong><br>
                - Habilitação/Divergência Final: <strong>${this.contraditory.end_value}</strong><br>
                - Data contraditório: <strong>${this.formattedContaditoryDate}</strong>`,

                title: "Confirmar alteração",
                actions: {
                    false: "Cancelar",
                    true: "Confirmar"
                }
            });

            if (!proceedAction) {
                this.contraditoryModal = false;
                return;
            }

            this.loadingContraditory = true;

            try {

                let payload = this.buildPayload();

                const response = await axios.patch(`/api/admin/user-objection-events/contradictory-deadline-range`, payload);

                this.$dialog.notify.info("Prazo contraditório dos registros atualizado com sucesso!", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {

                this.contraditory.start_value = 0;
                this.contraditory.end_value = 0;
                this.contraditory.deadline_date = null;
                this.formattedContaditoryDate = null;
                this.loadingContraditory = false;
                this.contraditoryModal = false;
                this.load();
            }
        },

        buildPayload() {
            const data = {
                start_value: this.contraditory.start_value,
                end_value: this.contraditory.end_value,
                deadline_date: this.contraditory.deadline_date
            }

            return data;
        },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.slice(0, maxLength) + '...';
            }
            return text;
        },

        viewItem(item) {
            const route = this.$router.resolve({
                path: `/revisao-credito/${item.id}`,
            });
            window.open(route.href, '_blank');
        },

        async saveRedirectMultiple() {

            if (
                !this.dataset.redirectMultiple.responsible_id
                || !this.dataset.redirectMultiple.req_quantity
            ) {
                this.$dialog.notify.error(
                    "Preencha os campos obrigatórios para continuar!",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            }

            const responsible = this.dataset.admins.find(
                admin => admin.id === this.dataset.redirectMultiple.responsible_id
            );

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja confirmar a atribuição dos pedidos para o(a) <br>
                    responsável <strong>${responsible.name.toUpperCase()}</strong> conforme as regras selecionadas?`,
                title: 'Atenção!',
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            this.loadingResponsibleRedirect = true;

            let payload = this.buildPayloadRedirect();

            try {

                const response = await axios.patch(`/api/admin/user-objection-events/responsible-event-range-redirect`, payload);

                if (response.data && response.data.status) {
                    const message = response.data.content || "Responsável atribuído com sucesso!";

                    this.$dialog.notify.info(message, {
                        position: "top-right",
                        timeout: 5000
                    });
                } else {
                    this.$dialog.notify.error("Erro desconhecido ao atribuir responsável.", {
                        position: "top-right",
                        timeout: 5000
                    });
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                })
            } finally {
                this.loadingResponsibleRedirect = false;
                this.closeModalRedirectMultiple();
                this.load();
            }
        },

        buildPayloadRedirect() {
            const data = {
                req_quantity: this.dataset.redirectMultiple.req_quantity,
                creditor_type: this.dataset.redirectMultiple.creditor_type,
                amount_plus: this.dataset.redirectMultiple.amount_plus,
                amount_minus: this.dataset.redirectMultiple.amount_minus,
                fgts_amount: this.dataset.redirectMultiple.fgts_amount,
                creditor_origin: this.dataset.redirectMultiple.creditor_origin,
                justification_id: this.dataset.redirectMultiple.justification_id,
                has_process: this.dataset.redirectMultiple.has_process,
                process_court_uf: this.dataset.redirectMultiple.process_court_uf,
                responsible_id: this.dataset.redirectMultiple.responsible_id,
                has_contradictory: this.dataset.redirectMultiple.has_contradictory,
                without_responsible: this.dataset.redirectMultiple.without_responsible
            }

            return data;
        },

        async saveAdminChange() {

            if (!this.dataset.changeResponsible.from_responsible_id || !this.dataset.changeResponsible.to_responsible_id) {
                this.$dialog.notify.error(
                    "Preencha os campos obrigatórios para continuar!",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            }

            if (this.dataset.changeResponsible.from_responsible_id === this.dataset.changeResponsible.to_responsible_id) {
                this.$dialog.notify.error(
                    "Os responsáveis selecionados são iguais. Selecione responsáveis diferentes para continuar!",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Substituir responsável',
                actions: {
                    false: 'Cancelar',
                    true: 'Substituir'
                }
            })

            if (!proceedAction) return;

            this.loadingAdminChange = true;

            let payload = this.buildPayloadAdminChange();

            try {

                const response = await axios.patch(`/api/admin/user-objection-events/responsible-event-change`, payload);

                if (response.data && response.data.status) {
                    const message = response.data.content || "Responsável substituído com sucesso!";

                    this.$dialog.notify.info(message, {
                        position: "top-right",
                        timeout: 5000
                    });
                } else {
                    this.$dialog.notify.error("Erro desconhecido ao substituir responsável.", {
                        position: "top-right",
                        timeout: 5000
                    });
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                })
            } finally {
                this.loadingAdminChange = false;
                this.closeModalChangeResponsible();
                this.load();
            }
        },

        buildPayloadAdminChange() {
            const data = {
                status: this.dataset.changeResponsible.status,
                rec_quantity: this.dataset.changeResponsible.rec_quantity,
                from_responsible_id: this.dataset.changeResponsible.from_responsible_id,
                to_responsible_id: this.dataset.changeResponsible.to_responsible_id,
                has_process: this.dataset.changeResponsible.has_process,
            }

            return data;
        },

        saveFiltersToStorage() {
            const filters = { ...this.dataList.filter, status: this.normalizeStatusValue(this.dataList.filter.status) };
            const cleanedFilters = {};

            Object.keys(filters).forEach(key => {
                if (filters[key] !== null && filters[key] !== '' && filters[key] !== undefined) {
                    cleanedFilters[key] = filters[key];
                }
            });

            localStorage.setItem(STORAGE_KEY, JSON.stringify({
                filters: cleanedFilters,
                selectedStatus: this.normalizeStatusValue(this.selectedStatus),
                categoryTab: this.normalizedCategoryTab,
                objectionVersionTab: this.objectionVersionTab,
                quickFilter: {
                    category: this.selectedQuickFilter.category,
                    value: this.normalizeStatusValue(this.selectedQuickFilter.value)
                },
                quickFilterKey: this.selectedQuickChipKey
            }));
        },

        loadFiltersFromStorage() {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return;

            try {
                const parsed = JSON.parse(raw);

                if (parsed.filters) {
                    this.dataList.filter = { ...this.dataList.filter, ...parsed.filters };
                }

                if (parsed.objectionVersionTab !== undefined) {
                    this.objectionVersionTab = parsed.objectionVersionTab;
                }

                const restoredStatus = this.normalizeStatusValue(
                    parsed.selectedStatus !== undefined ? parsed.selectedStatus : this.dataList.filter.status
                );

                const restoredCategory =
                    parsed.quickFilter && parsed.quickFilter.category
                        ? String(parsed.quickFilter.category).replace('#', '')
                        : String(parsed.categoryTab || 'status').replace('#', '');

                this.categoryTab = restoredCategory;
                this.selectedStatus = restoredStatus;
                this.dataList.filter.status = restoredStatus;
                this.currentStatusLabel = this.getStatusLabel(restoredStatus);

                this.selectedQuickFilter = {
                    category: restoredCategory,
                    value: restoredStatus
                };

                const savedKey = parsed.quickFilterKey;
                const rebuiltKey = `${restoredCategory}-${String(restoredStatus)}`;
                this.selectedQuickChipKey = savedKey || rebuiltKey;

            } catch (error) {
                console.error('Erro ao recuperar filtros do localStorage', error);
            }
        },

        sortCreatedAt() {

            this.sortDateDesc = !this.sortDateDesc

            this.dataList.data.sort((a, b) => {

                const A = new Date(a.created_at)
                const B = new Date(b.created_at)

                if (this.sortDateDesc) {
                return B - A
                }

                return A - B

            })
        },

        onObjectionVersionTabChange() {
            this.dataList.options.page = 1;
            this.load();
        },

    },
};
</script>

<style>
.card-title {
    padding-bottom: 8px !important;
    display: flex !important;
    font-weight: 650 !important;
    font-size: 20px !important;
    font-style: bold !important;
    color: var(--v-primary-base);
}

.menu-item {
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.menu-item:hover {
    background-color: #f5f5f5;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
}

.v-menu__content {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

.v-tab {
    text-transform: none;
    font-weight: 500;
    font-size: 13px;
    min-width: 120px;
    padding: 0 8px;
}

.v-icon {
    margin-right: 4px;
}

.tab-text {
    font-size: 12px;
    line-height: 1.2;
}

.v-chip.quick-chip-selected,
.v-chip.quick-chip-selected.v-chip--outlined {
    background-color: #b0bec5 !important;
    color: #1a1a1a !important;
    border-color: #78909c !important;
    border-width: 2px !important;
    font-weight: 700 !important;
    opacity: 1 !important;
    box-shadow: 0 2px 6px rgba(0,0,0,0.25) !important;
}

.v-chip.quick-chip-selected::before {
    background-color: transparent !important;
    opacity: 0 !important;
}

.v-chip.quick-chip-active,
.v-chip.quick-chip-active.v-chip--outlined {
    background-color: var(--v-primary-base) !important;
    color: #ffffff !important;
    border-color: var(--v-primary-base) !important;
    border-width: 2px !important;
    transition: all 0.2s ease;
}

.v-chip.quick-chip-active::before {
    background-color: transparent !important;
    opacity: 0 !important;
}

.status-label-chip {
    font-size: 12px !important;
    letter-spacing: 0.3px;
    border: 1px solid #90a4ae !important;
    padding: 0 10px !important;
    height: 26px !important;
}


</style>
